module.exports = __webpack_public_path__ + "img/LSUsportsnet.bf023949.svg";